"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateQuestionDefaultResponses = void 0;
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var types_1 = require("../../types");
var contentParser_1 = require("./contentParser");
var prefill_1 = require("./prefill");
function generateQuestionDefaultResponses(_a) {
    var sections = _a.sections, owner = _a.owner, displayConditions = _a.displayConditions, existingResponses = _a.existingResponses, _b = _a.prefillAlternates, prefillAlternates = _b === void 0 ? [] : _b;
    var responses = __spreadArrays(existingResponses);
    for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
        var section = sections_1[_i];
        var _loop_1 = function (item) {
            if (!types_1.isQuestionDTO(item)) {
                return "continue";
            }
            if (responses.some(function (r) { return r.questionId === item.id; })) {
                return "continue";
            }
            var questionResponses = generateResponsesForQuestion(item, owner, prefillAlternates);
            responses = responses.concat(questionResponses);
            for (var _i = 0, questionResponses_1 = questionResponses; _i < questionResponses_1.length; _i++) {
                var response = questionResponses_1[_i];
                if (response.parentContent) {
                    responses = prefill_1.prefillFromQuestionContent({
                        question: item,
                        content: response.parentContent,
                        displayConditions: displayConditions,
                        sections: sections,
                        existingResponses: responses,
                        prefillAlternates: prefillAlternates,
                    });
                }
            }
        };
        for (var _c = 0, _d = section.items; _c < _d.length; _c++) {
            var item = _d[_c];
            _loop_1(item);
        }
    }
    return responses.map(function (r) { return lodash_1.omit(r, "parentContent"); });
}
exports.generateQuestionDefaultResponses = generateQuestionDefaultResponses;
function generateResponsesForQuestion(question, owner, prefillAlternates) {
    var _a, _b, _c, _d, _e;
    if ((_a = question.properties) === null || _a === void 0 ? void 0 : _a.defaultToday) {
        return [
            {
                questionId: question.id,
                timeAnswered: new Date().toISOString(),
                answer: formatDateAnswer(new Date()),
            },
        ];
    }
    if ((_b = question.properties) === null || _b === void 0 ? void 0 : _b.defaultNow) {
        return [
            {
                questionId: question.id,
                timeAnswered: new Date().toISOString(),
                answer: question.subType === "TIME"
                    ? formatTimeAnswer(new Date())
                    : formatDateAnswer(new Date()),
            },
        ];
    }
    switch ((_c = question.answerSource) === null || _c === void 0 ? void 0 : _c.type) {
        case "CURRENT_PARTICIPANT":
            return contentParser_1.parseResponses(owner, {
                prefillAnswerField: ((_d = question.answerSource.properties) === null || _d === void 0 ? void 0 : _d.prefillAnswerField) || "fullName",
                prefillAssociatedIdField: ((_e = question.answerSource.properties) === null || _e === void 0 ? void 0 : _e.prefillAssociatedIdField) || "id",
            }, question, prefillAlternates);
        case "CURRENT_DATE":
            return [
                {
                    questionId: question.id,
                    timeAnswered: new Date().toISOString(),
                    answer: question.subType === "TIME"
                        ? formatTimeAnswer(new Date())
                        : formatDateAnswer(new Date()),
                },
            ];
    }
    return [];
}
function formatDateAnswer(date) {
    return date.toISOString();
}
function formatTimeAnswer(date) {
    return moment_1.default(date, "HH:mm").toISOString();
}
//# sourceMappingURL=nonDisplayConditionPrefill.js.map